import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Social',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "49",
    height: "48",
    viewBox: "0 0 49 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M23.9783 20.6279L25.007 24.467M11.9858 21.2697L8.65334 22.1626C7.03043 22.5974 6.21897 22.8149 5.68319 23.2948C5.21191 23.7169 4.88663 24.2762 4.75398 24.8924C4.60317 25.5929 4.81921 26.3992 5.2513 28.0118L5.5599 29.1635C5.79955 30.0579 5.91937 30.5051 6.16095 30.8184C6.48304 31.2362 6.95925 31.5091 7.48481 31.5771C7.87898 31.6281 8.32904 31.5075 9.22918 31.2663L10.3221 35.3453C10.3818 35.5681 10.4117 35.6795 10.4461 35.7709C10.7807 36.658 11.6995 37.1846 12.6408 37.0286C12.7377 37.0125 12.8498 36.9825 13.0741 36.9224C13.2984 36.8623 13.4105 36.8323 13.5025 36.7977C14.3956 36.4622 14.9281 35.5467 14.7742 34.6112C14.7584 34.5148 14.7285 34.4034 14.6688 34.1806L13.5758 30.1016L14.3003 29.9075C16.0065 29.4503 18.3372 29.7998 20.1812 30.2406C21.2569 30.4977 21.7948 30.6262 22.0924 30.5064C22.3683 30.3952 22.5499 30.2102 22.6549 29.9331C22.7681 29.6343 22.6338 29.1332 22.3653 28.1309L19.8586 18.7757C19.59 17.7735 19.4557 17.2723 19.2083 17.0702C18.9789 16.8827 18.7291 16.8133 18.4345 16.855C18.1168 16.9 17.7153 17.2802 16.9122 18.0408C15.5357 19.3444 13.692 20.8125 11.9858 21.2697Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M44.333 12C44.333 15.866 41.0608 19 37.0243 19C36.0985 19 35.2128 18.8351 34.3976 18.5343C34.2486 18.4793 34.1741 18.4518 34.1148 18.4388C34.0565 18.4259 34.0143 18.4205 33.9546 18.4183C33.8938 18.4161 33.8271 18.4227 33.6938 18.4359L29.2905 18.8718C28.8707 18.9134 28.6608 18.9342 28.537 18.8618C28.4291 18.7988 28.3557 18.6936 28.3361 18.574C28.3137 18.4368 28.414 18.259 28.6146 17.9033L30.021 15.4101C30.1368 15.2048 30.1947 15.1021 30.2209 15.0034C30.2469 14.9059 30.2531 14.8356 30.2448 14.7353C30.2364 14.6337 30.1899 14.5016 30.0969 14.2372C29.8497 13.5347 29.7157 12.7823 29.7157 12C29.7157 8.13401 32.9879 5 37.0243 5C41.0608 5 44.333 8.13401 44.333 12Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M37.0217 9.89938C36.2481 9.04386 34.958 8.81373 33.9887 9.59713C33.0195 10.3805 32.883 11.6903 33.6442 12.6169C34.1158 13.1909 35.2994 14.2393 36.1318 14.954C36.4375 15.2165 36.5904 15.3477 36.7739 15.4006C36.9313 15.446 37.1121 15.446 37.2695 15.4006C37.453 15.3477 37.6058 15.2165 37.9116 14.954C38.744 14.2393 39.9276 13.1909 40.3992 12.6169C41.1604 11.6903 41.0406 10.3723 40.0546 9.59713C39.0687 8.82197 37.7953 9.04386 37.0217 9.89938Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M35.153 34V27.95M32.333 29.05V32.9C32.333 33.5075 32.838 34 33.461 34H41.0333C41.8684 34 42.5786 33.4058 42.7056 32.6009L43.313 28.7509C43.4707 27.7514 42.6777 26.85 41.6407 26.85H39.6649C39.3534 26.85 39.1009 26.6038 39.1009 26.3V24.3562C39.1009 23.6072 38.4783 23 37.7102 23C37.527 23 37.361 23.1052 37.2866 23.2685L35.3018 27.6234C35.2113 27.822 35.0093 27.95 34.7864 27.95H33.461C32.838 27.95 32.333 28.4425 32.333 29.05Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_5)
  ], 8, _hoisted_1))
}
}

})